import { Flex, Layout } from 'antd';
import styled from 'styled-components';

export const StyledLayout = styled(Layout)`
    min-height: 60vh;
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const HeaderRow = styled(Flex)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;
